import request from '@/api/request.js'

/** 2026-09-10：公共图片库接口；图片条目 ID 稳定，文件版本可替换。 */
const imageAsset = {
  options: () => request({ url: '/admin_image_asset/options', method: 'GET' }),
  list: params => request({ url: '/admin_image_asset/index', method: 'GET', params }),
  upload(formData) {
    return request({ url: '/admin_image_asset/upload', method: 'POST', data: formData, headers: { 'Content-Type': 'multipart/form-data' } })
  },
  replace(formData) {
    return request({ url: '/admin_image_asset/replace', method: 'POST', data: formData, headers: { 'Content-Type': 'multipart/form-data' } })
  },
  update: data => request({ url: '/admin_image_asset/update', method: 'POST', data }),
  versions: params => request({ url: '/admin_image_asset/versions', method: 'GET', params }),
  deleteImpact: params => request({ url: '/admin_image_asset/deleteImpact', method: 'GET', params }),
  moveToRecycleBin: data => request({ url: '/admin_image_asset/moveToRecycleBin', method: 'POST', data }),
  recycleBin: params => request({ url: '/admin_image_asset/recycleBin', method: 'GET', params }),
  restore: data => request({ url: '/admin_image_asset/restore', method: 'POST', data }),
  purgeNow: data => request({ url: '/admin_image_asset/purgeNow', method: 'POST', data }),
  restoreVersion: data => request({ url: '/admin_image_asset/restoreVersion', method: 'POST', data }),
  keepVersion: data => request({ url: '/admin_image_asset/keepVersion', method: 'POST', data }),
  purgeVersion: data => request({ url: '/admin_image_asset/purgeVersion', method: 'POST', data })
}

export default imageAsset
